"use client";
import AnimatedText from "@/components/common/AnimatedText";
import { parallaxMouseMovement } from "@/utlis/parallax";
import Image from "next/image";

import { useEffect, useState } from "react";
import ModalVideo from "react-modal-video";

export default function Hero1() {
  useEffect(() => {
    parallaxMouseMovement();
  }, []);
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className="container min-height-100vh d-flex align-items-center pt-100 pb-100 pt-sm-120 pb-sm-120">
        {/* Home Section Content */}
        <div className="home-content text-start">
          <div className="row">
            {/* Home Section Text */}
            <div className="col-md-6 d-flex align-items-center mb-sm-60">
              <div>
                {/* <h2
                  className="section-caption mb-30 mb-xs-10 wow fadeInUp"
                  data-wow-duration="1.2s"
                >
                  Resonance Creative Studio
                </h2> */}
                <h1 className="hs-title-1 mb-30">
                  {/* <AnimatedText
                    text={"Exceptional Customer Experiences at GetBiz Solutions"}
                  /> */}
                  Exceptional Customer Experiences at GetBiz Solutions
                </h1>

                <p
                  className="section-descr mb-50"
                >
                  Hear from our 100+ satisfied customers. Discover why businesses trust GetBiz Solutions to drive success and satisfaction.
                </p>
                <div className="local-scroll mt-n10 wch-unset" >
                  <a
                    href="/book-demo/"
                    className="btn btn-mod btn-large btn-round btn-hover-anim align-middle me-2 me-sm-5 mt-10"
                  >
                    <span>Book A Demo</span>
                  </a>
                  {/* <a
                    onClick={() => setOpen(true)}
                    className="link-hover-anim align-middle lightbox mfp-iframe mt-10"
                    data-link-animate="y"
                  >
                    <i className="icon-play size-13 me-1" /> How it works?
                  </a> */}
                </div>
              </div>
            </div>
            {/* End Home Section Text */}
            {/* Stack Images */}
            <div className="col-md-5 offset-md-1 d-flex align-items-center">
              <Image
                // src="/assets/images/stack-image-1.jpg"
                src="/assets/images/img/all_images/customer_hero_images.webp"
                alt="customer Image Description"
                width={600}
                height={800}
              />
            </div>
            {/* End Stack Images */}
          </div>
        </div>
        {/* End Home Section Content */}
        {/* Scroll Down */}
        <div
          className="local-scroll scroll-down-wrap-type-1"
          data-wow-offset={0}
        >
          <div className="container">
            {/* x-link */}
            <a href="/" className="scroll-down-1" aria-label="Scroll Down">
              <div className="scroll-down-1-icon">
                <i className="mi-arrow-down" />
              </div>
              <div className="scroll-down-1-text">Scroll Down</div>
            </a>
          </div>
        </div>
        {/* End Scroll Down */}
      </div>
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="jTea_8Fk5Ns"
        onClose={() => setOpen(false)}
      />
    </>
  );
}
